import * as Types from '../types-api.generated';

import { WorldFragment, WorldOverviewFragment, UserLightFragment, MomentStatsFragment, MediaFragment, EditionSaleConfigurationFragment, DropSaleConfigurationFragment } from '../api-fragments.generated';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiWorldBySlugVariables = Types.Exact<{
  slug: Types.Scalars['String'];
}>;


export type ApiWorldBySlug = { world: { curatorAddress: Address, description: string | null, moderationFrom: string | null, chainId: ChainId, id: number, name: string, slug: string, moderationStatus: Types.ApiModerationStatus, imageUrl: string | null, coverUrl: string | null, takeRateInBasisPoints: number, curator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } } | null };



export const ApiWorldBySlugDocument = /*#__PURE__*/ `
    query WorldBySlug($slug: String!) {
  world(slug: $slug) {
    ...WorldFragment
  }
}
    ${WorldFragment}
${WorldOverviewFragment}
${UserLightFragment}`;

export const useWorldBySlug = <
      TData = ApiWorldBySlug,
      TError = ClientError
    >(
      variables: ApiWorldBySlugVariables,
      options?: Omit<UseQueryOptions<ApiWorldBySlug, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiWorldBySlug, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiWorldBySlug, TError, TData>(
      {
    queryKey: ['WorldBySlug', variables],
    queryFn: apiFetcher<ApiWorldBySlug, ApiWorldBySlugVariables>(ApiWorldBySlugDocument, variables),
    ...options
  }
    )};

useWorldBySlug.getKey = (variables: ApiWorldBySlugVariables) => ['WorldBySlug', variables];

export const useInfiniteWorldBySlug = <
      TData = InfiniteData<ApiWorldBySlug>,
      TError = ClientError
    >(
      variables: ApiWorldBySlugVariables,
      options: Omit<UseInfiniteQueryOptions<ApiWorldBySlug, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiWorldBySlug, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApiWorldBySlug, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['WorldBySlug.infinite', variables],
      queryFn: (metaData) => apiFetcher<ApiWorldBySlug, ApiWorldBySlugVariables>(ApiWorldBySlugDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteWorldBySlug.getKey = (variables: ApiWorldBySlugVariables) => ['WorldBySlug.infinite', variables];


useWorldBySlug.fetcher = (variables: ApiWorldBySlugVariables, options?: RequestInit['headers']) => apiFetcher<ApiWorldBySlug, ApiWorldBySlugVariables>(ApiWorldBySlugDocument, variables, options);
